function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2V2a2.006 2.006 0 0 0-2-2Zm0 14H2V4l8 5 8-5Zm-8-7L2 2h16Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgMail;